import React from "react";
import "./ModalSuccesErrorPasarela.css";
import Modal from "react-bootstrap/Modal";
const ModalSuccesErrorPasarela = ({ inputsShowTypes, handleClose }) => {
  const {
    show,
    type,
    title,
    msg,
    preliquidacion,
    numeroTarjeta,
    monto,
    periodo,
    nombres,
    msgWarning,
  } = inputsShowTypes || {};

  const obetenerFechaActual = () => {
    
    const currentDate = new Date();

     
    const day = currentDate.getDate().toString().padStart(2, "0");
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Los meses se indexan desde 0, por lo que se suma 1
    const year = currentDate.getFullYear();
    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();

    
    const formattedDate = `${day}/${month}/${year} - ${hours
      .toString()
      .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

  
    return formattedDate;
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="md"
      backdrop={true}
      backdropClassName="modalGenerateCode"
      className="modalSuccesErrorPasarela"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        {type === "success" ? (
          <form className="steps-form">
            <div className="col-sm-12 col-md-12 col-lg-12 steps-container prints">
              <div className="card">
                <div className="card-body">
                  <fieldset>
                    <div
                      className="form-body pago"
                      style={{ minHeight: "49vh" }}
                    >
                      <div className="text-center">
                        <div className="success-animation mb-4">
                          <svg
                            className="checkmark-animation"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 52 52"
                            style={{ width: 51, height: 51 }}
                          >
                            <circle
                              className="checkmark__circle"
                              cx={26}
                              cy={26}
                              r={25}
                              fill="none"
                            />
                            <path
                              className="checkmark__check"
                              fill="none"
                              d="M14.1 27.2l7.1 7.2 16.7-16.8"
                            />
                          </svg>
                        </div>
                      </div>
                      <div className="text-center confirmation-title mb-4">
                        <h3 className="text-uppercase mb-4">{msg}</h3>
                        <p className="mb-0">
                          <span className="fw-medium">{nombres}</span>, su pago
                          ha sido exitoso.
                        </p>
                      </div>
                      <div className="border br-3 p-3 detalle-pago">
                        <h5>Detalle del Pago:</h5>
                        <p className="label-compra">Matrícula {periodo}</p>
                        <div className="row">
                          <div className="col-sm-12 col-md-6">
                            <p className="mb-0">N° de Pre-liquidación: </p>
                            <p>
                              <span className="fw-medium">
                                {preliquidacion}
                              </span>{" "}
                            </p>
                          </div>
                          <div className="col-12 ">
                            <p className="mb-0">Comercio:</p>
                            <p>
                              <span className="fw-medium">
                                UNIVERSIDAD PERUANA CAYETANO HEREDIA
                              </span>
                            </p>
                          </div>
                          <div className="col-sm-12 col-md-6">
                            <p className="mb-0">Fecha y hora:</p>
                            <p>
                              <span className="fw-medium">
                                {obetenerFechaActual()}
                              </span>{" "}
                            </p>
                          </div>
                          <div className="col-sm-12 col-md-6">
                            <p className="mb-0">Número de tarjeta:</p>
                            <p>
                              <span className="fw-medium">{numeroTarjeta}</span>{" "}
                            </p>
                          </div>
                          <div className="col-12">
                            <p className="mb-0">Monto y moneda:</p>
                            <p>
                              <span className="fw-medium">{monto}</span>{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn waves-effect waves-light btn-outline-danger siguiente d-block mx-auto mb-4"
                      onClick={() => {
                        window.print();
                      }}
                    >
                      {" "}
                      <svg
                        style={{ width: 24, height: 24, marginRight: 10 }}
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z"
                        />
                      </svg>{" "}
                      Imprimir
                    </button>
                  </fieldset>
                  {msgWarning !== "" && (
                    <div className="alert alert-warning" role="alert">
                      <p
                        className="mb-0"
                        style={{ lineHeight: "1.2", fontSize: 14 }}
                      >
                        <svg
                          viewBox="0 0 24 24"
                          style={{ width: 24, height: 24, marginRight: 5 }}
                        >
                          <path
                            fill="currentColor"
                            d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                          />
                        </svg>
                        {msgWarning}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        ) : (
          <>
            <div>
              <div
                className="swal2-icon swal2-error swal2-animate-error-icon"
                style={{ display: "flex" }}
              >
                <span className="swal2-x-mark">
                  <span className="swal2-x-mark-line-left" />
                  <span className="swal2-x-mark-line-right" />
                </span>
              </div>
            </div>
            <h5 className="text-uppercase text-center">ERROR </h5>
            <p className="text-center">{msg}</p>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalSuccesErrorPasarela;
